export default [
  {
    question: 'Apa itu layanan ride-hailing?',
    answer: 'Ride-hailing adalah layanan yang memungkinkan seseorang memesan transportasi umum melalui aplikasi elektronik. Layanan ini menyediakan fasilitas transportasi umum kepada pelanggan dengan kendaraan pribadi.'
  },
  {
    question: 'Bagaimana cara bergabung menjadi pengemudi dengan airasia Super App?',
    answer: 'Kirim aplikasi Anda di sini dan kami akan menghubungi Anda.'
  },
  {
    question: 'Apa saja persyaratan untuk menjadi pengemudi airasia ride?',
    answer: '<ul><li>Warga negara Indonesia</li><li>Memiliki Surat Izin Mengemudi (SIM) yang masih berlaku</li><li>Memiliki pengalaman mengemudi minimal 3 tahun</li></ul>'
  },
  {
    question: 'Apakah pengemudi harus memiliki mobil?',
    answer: 'Sebagai pengemudi airasia ride, Anda akan membutuhkan sebuah mobil untuk mengangkut penumpang dari satu titik ke titik lain.'
  },
  {
    question: 'Area mana saja yang tercakup oleh airasia ride?',
    answer: 'Saat ini airasia ride hanya mencakup area Bali saja. Nantikan kehadiran airasia ride di area lainnya.'
  },
  {
    question:'Berapa usia mobil saya jika saya ingin menjadi pengemudi airasia ride?',
    answer:'Usia mobil Anda tidak boleh lebih dari 10 tahun.'
  },
  {
    question:'Apakah airasia ride memberikan asuransi untuk pengemudi?',
    answer:'Ya, semua pengemudi airasia ride diberikan perlindungan asuransi.'
  }
]
